const appInfo = {
    title: 'Territorio Halcón'
};
export default appInfo;

